import axios from "axios";
import { BASE_URL } from "../utils/api";
import {
  clearLocalStorage,
  getItemLocalStorage,
} from "../utils/browserSetting";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = getItemLocalStorage("token");
  if (token) {
    config.headers = {
      Authorization: token,
      "Access-Control-Allow-Origin": "*",
    };
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.message === "Network Error" && !error.response) {
      console.log("Network error - make sure API is running!");
    }

    if (error.response) {
      const { status } = error.response;
      if (status === 404) {
        console.log("Not Found");
      } else if (status === 401) {
        if (typeof window !== "undefined" && window.location) {
          console.log("Your session has expired, please login again");
          // Optional: You could also redirect the user
          // window.location.href = "/";
          // clearLocalStorage();
        }
      }
    }

    // Reject the promise to propagate the error
    return Promise.reject(error);
  }
);

export default axiosInstance;
